module.exports = __webpack_public_path__ + "img/Logowall_mobile-before-old.c89beb4e.png";